import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/it/progetti')({
  component: Outlet,
})
